<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-app-bar dark color="accent">
              <v-icon class="mr-3">mdi-chart-areaspline</v-icon>
                <v-toolbar-title>Dashboard</v-toolbar-title>
              </v-app-bar>
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" md="3" lg="3">
                  <span>Year</span>
                  <v-select :items="year" v-model="changePointChartState" label="Please Select Year"
                            chips deletable-chips small-chips  solo>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <span>Branch</span>
                  <v-select :items="data.branch"  chips deletable-chips small-chips label="Please Select Branch"
                            solo />
                </v-col>
                <v-col cols="12" md="2" lg="2" class="mt-lg-7 mt-md-7 d-flex justify-end justify-md-start">
                  <v-btn @click="changeChartState" outlined color="primary"> <v-icon color="primary">
                    mdi-arrow-right-drop-circle-outline
                  </v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="6" md="6">
                    <v-card class="mx-auto">
                      <PointChart v-show="viewChart !== '2020'" :options="pointChart1A"/>
                      <PointChart v-show="viewChart === '2020'" :options="pointChart1B"/>
                    </v-card>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                  <v-card class="mx-auto">
                    <PointChart v-show="viewChart !== '2020'" :options="pointChart2A"/>
                    <PointChart v-show="viewChart === '2020'" :options="pointChart2B"/>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="6" md="6">
                  <v-card class="mx-auto">
                    <PointChart v-show="viewChart !== '2020'" :options="pointChart3A"/>
                    <PointChart v-show="viewChart === '2020'" :options="pointChart3B"/>
                  </v-card>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                  <v-card class="mx-auto">
                    <BarChart v-show="viewChart !== '2020'" :options="BarChart1A"/>
                    <BarChart v-show="viewChart === '2020'" :options="BarChart1B"/>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PointChart from '../charts/PointChart'
import BarChart from '../charts/BarChart'
// eslint-disable-next-line no-unused-vars
const data = require('../data/sample')
export default {
  name: 'Dashboard',
  components: {
    PointChart,
    BarChart,
  },
  data () {
    return {
      data,
      viewChart: '',
      pointChart1Enabled: true,
      pointChart2Enabled: true,
      items: [
        {
          text: 'Home',
          disabled: true,
          href: 'breadcrumbs_dashboar'
        },
        {
          text: 'Dashboard',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      year: [
        {
          text: '2019'
        },
        {
          text: '2020'
        }
      ],
      changePointChartState:'',
      regionalOffice: [
        {
          text:'HQ'
        },
        {
          text:'Central'
        },
        {
          text:'Northern'
        },
        {
          text:'Southern'
        },
        {
          text:'East Malaysia'
        },
        {
          text:'Eastern'
        },
      ],
      branches: [
        {
          text: 'Kuala Lumpur'
        },
        {
          text: 'Penang'
        }
      ],
      tab: null,
      e13: 1,
      pointChart1A:{
        chart: {
          type: 'area',
        },
        series: [{
          data: [7, 6, 9, 14, 18, 21, 25, 26, 23, 18, 13, 9],
            color: '#84C0DD'
        }],
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
          title: {
            text: 'Registered Customers',
            style: {
              fontSize: '18px'
            }
          }
        }
      },
      pointChart1B:{
        chart: {
          type: 'area',
        },
        series: [{
          data: [7, 5],
          color: '#84C0DD'
        }],
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: ['JAN', 'FEB'],
          title: {
            text: 'Registered Customers',
            style: {
              fontSize: '18px'
            }
          }
        }
      },
      pointChart2A:{
        chart: {
          type: 'area',
        },
        series: [{
          data: [21,7, 9, 14, 18,  25,  23, 6, 18, 13, 9,26],
          color: '#84C0DD'
        }],
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
          title: {
            text: 'Generated GFI Reports',
            style: {
              fontSize: '18px'
            }
          }
        }
      },
      pointChart2B:{
        chart: {
          type: 'area',
        },
        series: [{
          data: [2, 10],
          color: '#84C0DD'
        }],
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: ['JAN', 'FEB'],
          title: {
            text: 'Generated GFI Reports',
            style: {
              fontSize: '18px'
            }
          }
        }
      },
      pointChart3A:{
        chart: {
          type: 'area',
        },
        series: [{
          data: [21,7, 9, 14, 18,  25,  23, 6, 18, 13, 9,26],
            color: '#84C0DD'
        }],
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
          title: {
            text: 'No. of Applicants Rejected',
            style: {
              fontSize: '18px'
            }
          }
        }
      },
      pointChart3B:{
        chart: {
          type: 'area',
        },
        series: [{
          data: [10.0, 3],
          color: '#84C0DD'
        }],
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: ['JAN', 'FEB'],
          title: {
            text: 'No. of Applicants Rejected',
            style: {
              fontSize: '18px'
            }
          }
        }
      },
      BarChart1A: {
        xAxis: {
          categories: ['']
        },
        series: [
          {
            name: 'Registered',
            data: [50]
          },
          {
            name: 'Generated GFI Reports',
            data: [30]
          },
          {
            name: 'Rejected',
            data: [20]
          }]
      },
      BarChart1B: {
        xAxis: {
          categories: ['']
        },
        series: [
          {
            name: 'Registered',
            data: [20]
          },
          {
            name: 'Generated GFI Reports',
            data: [12]
          },
          {
            name: 'Rejected',
            data: [8]
          }]
      },
      filterBox:{
        year: ''
      }
    }
  },
  methods:{
    changeChartState: function () {
      this.viewChart = this.changePointChartState
    }
  },
  computed: {
    theme () {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
}
</script>
<style scoped>
  .v-stepper--vertical .v-stepper__step {
    padding: 15px 25px 0px;
  }

  .cardStyle {
    border: 3px solid green;
  }

  .v-breadcrumbs {
    padding: 7px 0px 0px 0px !important;
  }

  .v-card__text, .v-card__title {
    padding: 5px;
    padding-left: 10px;
  }


</style>
<style>
  .theme--dark.v-label {
    color: rgba(255, 255, 255, 1) !important;
    font-weight: bolder;
  }
  .v-btn__content {
    font-weight: bolder !important;
  }
</style>
